import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { SnackBarMessageType } from '../../../components/layout/snackbar/index'
import { open } from '../snack.bar/actions'
import { IActionType, IAxiosResponse } from '../root.types'
import { AlertTypes, IActionFind, IActionLoad, IActionUpdate } from './types'
import AlertService from "../../../services/alert"
import {
    findAlertFailure,
    findAlertSuccess,
    loadAlertFailure,
    loadAlertSuccess,
    updateAlertFailure,
    updateAlertSuccess,
} from './actions'
import { Alert } from '../../application/models/alert/alert'

function* loadAlert(action: IActionType<IActionLoad>) {
    try {
        const { startDate,endDate,paginator } = action.payload
        const alerts: IAxiosResponse<Alert[]> = yield apply(
            AlertService,
            AlertService.getAll,    
            [startDate,endDate,paginator]
        )
        yield put(loadAlertSuccess(alerts))
    } catch (e) {
        yield put(loadAlertFailure())
    }
}   

function* findAlert(action: IActionType<IActionFind>) {
    try {
        const {alertId} = action.payload
        const alert: IAxiosResponse<Alert> = yield apply(
            AlertService,
            AlertService.getById,
            [alertId]
        )
        yield put<any>(findAlertSuccess(alert))
    } catch (e) {
        yield put(findAlertFailure())
    }
}

function* updateAlert(action: IActionType<IActionUpdate>) {
    try {
        const { alert } = action.payload
        const alertUpdated: IAxiosResponse<Alert> = yield apply(
            AlertService,
            AlertService.updadeAlert,
            [alert]
        )

        yield put<any>(updateAlertSuccess(alertUpdated))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Alteração feito sucesso`)
        )
    } catch (e) {
        yield put(
            open(
                SnackBarMessageType.ERROR,
                '',
                `Erro ao fazer a alteração`)
        )
        yield put(updateAlertFailure())
    }
}

export default function* alertSaga() {
    return yield all([
        takeLatest(AlertTypes.LOAD_ALERT_REQUEST, loadAlert),
        takeLatest(AlertTypes.FIND_ALERT_REQUEST, findAlert),
        takeLatest(AlertTypes.UPDATE_ALERT_REQUEST, updateAlert),
    ])
}